import { render, staticRenderFns } from "./SimpleLine.vue?vue&type=template&id=2675b95e&scoped=true"
import script from "./SimpleLine.vue?vue&type=script&lang=js"
export * from "./SimpleLine.vue?vue&type=script&lang=js"
import style0 from "./SimpleLine.vue?vue&type=style&index=0&id=2675b95e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675b95e",
  null
  
)

export default component.exports